module.exports = __webpack_public_path__ + "img/minexLogo1.9a2b5f1d.png";